import { render, staticRenderFns } from "./QuestionCreate.vue?vue&type=template&id=745d1a5e&scoped=true&"
import script from "./QuestionCreate.vue?vue&type=script&lang=ts&"
export * from "./QuestionCreate.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionCreate.vue?vue&type=style&index=0&id=745d1a5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745d1a5e",
  null
  
)

export default component.exports